import React from 'react'
import AdFrame from '@chegg-wt/core/components/AdFrame'
import Footer from '@chegg-wt/core/components/Footer'
import Nav from '@chegg-wt/core/components/Nav'
import CheggLayout from '@chegg-wt/core/components/CheggLayout'
import GlobalModal from '@chegg-wt/core/components/Modals/GlobalModal'
import { Advert } from '@chegg-wt/core/components/Advert'
import * as Styled from './styled'

// these variables are for CTFM new layout experiment remove them once experiment is over
export const SVP_VARIANT_ONE = '1'
export const SVP_VARIANT_TWO = '2'

const AdFrameMaybe = ({ routeName, isPro, children, useAdframeLayout, showSvp }) =>
  useAdframeLayout ? (
    <AdFrame showSvp={showSvp} routeName={routeName} isPro={isPro}>
      {children}
    </AdFrame>
  ) : (
    <>{children}</>
  )

const TopAdMaybe = ({ isPro, useAdframeLayout, showSvp, variant }) => {
  if (showSvp) {
    return (
      <Styled.SvpTopWrapper variant={variant}>
        <Advert placement="T1" className="adds" hideAds={isPro} />
        <Styled.SvpHideWrapperT2 variant={variant}>
          <Advert placement="T2" className="adds svp-t2" hideAds={isPro} />
        </Styled.SvpHideWrapperT2>
      </Styled.SvpTopWrapper>
    )
  }
  return useAdframeLayout ? (
    <Advert placement="T1" className="adds top" hideAds={isPro} />
  ) : null
}

const AppLayout = ({
  isCheggFree,
  exportTabIds,
  children,
  hideLayout,
  hideAdRail,
  useAdframeLayout,
  routeName,
  isPro,
  errorPageMaybe,
  navItemsSelector,
  NotificationBanner,
  footerContents,
  showSvp,
  svpVariant,
  showBanner,
  bannerText,
  isHomePage,
}) => {
  /* TODO refactor this to show/hide layouts */
  if (isCheggFree) {
    return (
      <>
        <GlobalModal exportTabIds={exportTabIds} />
        <CheggLayout isCheggFree={isCheggFree}>{errorPageMaybe || children}</CheggLayout>
      </>
    )
  }

  if (hideAdRail || hideLayout) {
    return <>{errorPageMaybe || children}</>
  }

  return (
    <AdFrameMaybe
      showSvp={showSvp}
      routeName={routeName}
      isPro={isPro}
      useAdframeLayout={useAdframeLayout}
    >
      <GlobalModal exportTabIds={exportTabIds} />
      <Nav navItemsSelector={navItemsSelector} />
      {isHomePage && showBanner ? (
        <Styled.WelcomeBanner>{bannerText}</Styled.WelcomeBanner>
      ) : null}
      {NotificationBanner && <NotificationBanner />}
      <TopAdMaybe
        showSvp={showSvp}
        useAdframeLayout={useAdframeLayout}
        isPro={isPro}
        variant={svpVariant}
      />
      {errorPageMaybe || children}
      <Footer {...footerContents} />
    </AdFrameMaybe>
  )
}

export default AppLayout
